/** @jsx jsx */
import styled from '@emotion/styled';
import { Button, Typography } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import EditIcon from '@material-ui/icons/Edit';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import React from 'react';
import { Box } from '../../UI';
import { jsx, css, keyframes } from '@emotion/core'
import AllInboxIcon from '@material-ui/icons/AllInbox';
import { Link } from 'react-router-dom';

export default function Status({ data }) {
	let digitalId;
	!!data ? (digitalId = data.sell.digitalId) : (digitalId = 0);

	return (
		<Box display="flex" flexDirection="row" width='100%'>
			<Box flexGrow={1}>
				<Typography variant="body1">Digital ID</Typography>
				<StatusBar digitalId={digitalId}>
					<div />
				</StatusBar>
			</Box>
			<Box display="flex" flexDirection="row" alignItems="center">
				<Box>
					<Box display="flex" flexDirection="row" alignItems="center" justifyContent="flex-end">
						<Typography variant="body1">Status: {digitalId === 100 ? 'Active' : 'Inactive'}</Typography>
						<Dot className={digitalId === 100 && 'active'} />
					</Box>
					{digitalId !== 100 &&
						<Box display="flex" flexDirection="row" alignItems="center" justifyContent="flex-end">
							<Typography variant="body1">Process: {digitalId === 100 ? 'Uploaded' : 'Uploading'}</Typography>
							<FlashingDot className={digitalId === 100 && 'active'} css={css`animation: ${flash} 1s ease infinite;`} />
						</Box>
					}
				</Box>
				<Box ml="1rem">
					{digitalId === 100 && 
						<Button variant="contained" color="default" startIcon={<AllInboxIcon />} style={{ marginRight: '1rem' }} component={Link} to={`/my-portfolio/${data.id}/loi-report`}>
							LoI report
						</Button>
					}
					<Button variant="contained" color="default" startIcon={<EditIcon />} style={{ marginRight: '1rem' }}>
						Edit
					</Button>
					{digitalId === 100 ? (
						<Button variant="contained" color="primary" startIcon={<CancelIcon />}>
							Deactivate
						</Button>
					) : (
							<Button variant="contained" color="primary" startIcon={<CheckCircleIcon />} disabled>
								Activate
							</Button>
						)}
				</Box>
			</Box>
		</Box>
	);
}

const StatusBar = styled.div`
	width: 400px;
	height: 15px;
	border-radius: 10px;
	overflow: hidden;
	background: #c1c1c1;
	& > div {
		height: 100%;
		${({ digitalId }) => `width: ${digitalId}%`}
	}
	& > div {
		${({ digitalId }) => {
		if (digitalId < 50) {
			return `
					background: #f44336;
				`;
		} else if (digitalId >= 50 && digitalId < 80) {
			return `
					background: #ff9800;
				`;
		} else {
			return `
					background: #4caf50;
				`;
		}
	}}
	}
`;

const Dot = styled.div`
	width: 10px;
	height: 10px;
	border-radius: 100%;
	margin-left: 10px;
	background: #f44336;
	&.active {
		background: #77aa79;
	}
`;

const FlashingDot = styled.div`
	width: 10px;
	height: 10px;
	border-radius: 100%;
	margin-left: 10px;
`;
const flash = keyframes`
	0%{     background: #ff7f41;    }
	49%{    background: #ff7f41; }
	60%{    background: #e2e2e2; }
	99%{    background: #e2e2e2;  }
	100%{   background: #ff7f41;    }
`